import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/var/www/html/app/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/html/app/layouts/default.vue").then(m => m.default || m))
}